export const customLocales = ['en', 'da', 'de'] as const;
export type DlCustomLocale = (typeof customLocales)[number];
